import { StorageType } from 'storage-service-lib';
import {buildVersion} from './build.version';

export const environment = {
  production: false,
  identityStorageType: StorageType.SESSION,
  name: 'qa-tester4',
  featureFlagsUrl: 'https://platform-dev.kyloe.io/feature-flags/api/v1/client-init',
  featureFlagsApiKey: 'Kv5tiKDe4i8O7jFYZz5wNawc3d3hqJ8L7KlKXTRa',
  version: buildVersion,

  uiHost: 'https://tester4.ai-assist-qa.kyloe.plus',
  environmentIdentifier: 'QA-Tester4',
  kpHost: 'https://tester4.backend-qa.awesome-docs.io',
  kpWorkflowHost: 'https://tester4.backend-qa.awesome-docs.io',
  kpWorkflowStatus: 'wss://tester4.backend-qa.awesome-docs.io',

  tinyApiKey: 'otczu6qwnj0e2gany3t5c19lmvh3zas03bq70mawwp2ns5iw',

  apiGatewayUrl: 'https://ai-assist-api.kyloe.plus/qa-internal',
  apiGatewayKey: 'nKks0HMmW37nqziQQR0LZ2RZLpUlXUxK1ACj76O8',

  ntApiGatewayUrl: 'https://ai-notetaker-api.kyloe.plus/qa',
  ntApiGatewayKey: 'Z2DpCWHUZL6mPc7Kwgcus7OrmvokmMCP2fpDq0Mk',

  dtApiGatewayUrl: 'https://api-datatoolsadmin.kyloe.plus/qa-internal',
  dtApiGatewayKey: 'uQHY56PPM679nGk1fLPJb1d7G88WPhLo5V0ToR21',

  adApiGatewayUrl: 'https://api-datatoolsadmin.kyloe.plus/qa-internal',
  adApiGatewayKey: 'PbFTLDLVTF1JateBwg0TG4KxU7hZvzJKzzykQqQh',
  ntIntegrationApiUrl: 'https://ai-api-eu-qa.kyloe.plus',
  nt8x8ApiUrl: 'https://ai-api-8x8-eu-qa.kyloe.plus',
  ntInviteDomain: 'transcribe@notetaker-qa.kyloe.plus',

  tempNoteTakerbucket: 'note-taker-qa-internal',
  s3tempbucket: 'adv2-temp-qa-internal',

  enableAnalytics: false,

  calendarGatewayUrl: 'https://x0z4n4at7a.execute-api.eu-west-1.amazonaws.com/qa/',
  calendarApiUrl: 'https://8nnj81duai.execute-api.eu-west-1.amazonaws.com/Prod',
  calendarClientId: 'fdaa27e5-bc8d-400a-85a8-b58d839d6fb9',

  /* PENDO */
  aiaBhCardPendoAPIKey: '91b0b347-01c0-47a4-55fe-577c1a3997e7',
  aiaManagerPendoAPIKey: '91b0b347-01c0-47a4-55fe-577c1a3997e7',

  ntBhCardPendoAPIKey: '91b0b347-01c0-47a4-55fe-577c1a3997e7',
  ntManagerPendoAPIKey: '91b0b347-01c0-47a4-55fe-577c1a3997e7',

  defaultBillingStartDate: '2025-10-01',
  dateFormat: 'en-GB',

};

export const runtimeEnvironment = {
  client: { name: undefined }, // e.g names: kyloedev or amos-s3 or 9648
  origin: { url: undefined, namespace: undefined }, // e.g. https://kyloedev.invenias.com, invenias or invenias-mock or bullhorn
  runningAsChromeExtension: false,
  renderMode: 'web-app',
  jwt: undefined, // TODO: move this?
};
